module.exports = new __parcel__URL__("73091264-4.b3a35e5c.png").toString();